import { useEffect } from 'react';
import type { PaletteMode } from '@mui/material';

type Props = {
  setMode: (mode: PaletteMode) => void;
};

const useSystemColorScheme = ({ setMode }: Props) => {
  useEffect(() => {
    window?.matchMedia?.('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
      const colorScheme = event.matches ? 'dark' : 'light';
      setMode(colorScheme);
    });
  }, []);
};

export default useSystemColorScheme;
